/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Founder_Chris_RoleInputs */

const en_about_founder_chris_role = /** @type {(inputs: About_Founder_Chris_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Operations`)
};

const de_about_founder_chris_role = /** @type {(inputs: About_Founder_Chris_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgruender & Operations`)
};

const fr_about_founder_chris_role = /** @type {(inputs: About_Founder_Chris_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-fondateur & Opérations`)
};

const es_about_founder_chris_role = /** @type {(inputs: About_Founder_Chris_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cofundador y operaciones`)
};

const it_about_founder_chris_role = /** @type {(inputs: About_Founder_Chris_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cofondatore e operazioni`)
};

const nl_about_founder_chris_role = /** @type {(inputs: About_Founder_Chris_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medeoprichter en operaties`)
};

const pl_about_founder_chris_role = /** @type {(inputs: About_Founder_Chris_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wspolzalozyciel i operacje`)
};

const fi_about_founder_chris_role = /** @type {(inputs: About_Founder_Chris_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perustaja ja operaatiot`)
};

const da_about_founder_chris_role = /** @type {(inputs: About_Founder_Chris_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medstifter og drift`)
};

const sv_about_founder_chris_role = /** @type {(inputs: About_Founder_Chris_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medgrundare och drift`)
};

/**
* | output |
* | --- |
* | "Co-Founder & Operations" |
*
* @param {About_Founder_Chris_RoleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_founder_chris_role = /** @type {((inputs?: About_Founder_Chris_RoleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Founder_Chris_RoleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_founder_chris_role(inputs)
	if (locale === "fr") return fr_about_founder_chris_role(inputs)
	if (locale === "es") return es_about_founder_chris_role(inputs)
	if (locale === "it") return it_about_founder_chris_role(inputs)
	if (locale === "nl") return nl_about_founder_chris_role(inputs)
	if (locale === "pl") return pl_about_founder_chris_role(inputs)
	if (locale === "fi") return fi_about_founder_chris_role(inputs)
	if (locale === "da") return da_about_founder_chris_role(inputs)
	if (locale === "sv") return sv_about_founder_chris_role(inputs)
	return en_about_founder_chris_role(inputs)
});